export default __webpack_public_path__ + "static/platform-connect-1e4457a6b2458c6dffdd6c16f689a29d.png";